// Import the functions you need from the SDKs you need
import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, initializeAuth, inMemoryPersistence, browserLocalPersistence, setPersistence, GoogleAuthProvider, Auth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY!),
  isTokenAutoRefreshEnabled: true
});

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Export firestore database
const db = getFirestore(app);
// Firebase storage
const storage = getStorage(app);

setPersistence(auth, browserLocalPersistence);

// Instância secundária usada SÓ pelo admin para criar contas de outros usuários
// (utils/adminCreateUser.ts). createUserWithEmailAndPassword loga na conta recém-criada;
// numa instância separada, com sessão só em memória, a sessão do admin na instância
// principal não é tocada. Criada sob demanda e reaproveitada nas próximas criações.
const ISOLATED_APP_NAME = "admin-user-creation";

export function getIsolatedFirebase(): { app: FirebaseApp, auth: Auth, db: Firestore } {
  const existing = getApps().find(a => a.name === ISOLATED_APP_NAME);
  if (existing) {
    return { app: existing, auth: getAuth(existing), db: getFirestore(existing) };
  }
  const isolatedApp = initializeApp(firebaseConfig, ISOLATED_APP_NAME);
  initializeAppCheck(isolatedApp, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY!),
    isTokenAutoRefreshEnabled: true
  });
  const isolatedAuth = initializeAuth(isolatedApp, { persistence: inMemoryPersistence });
  return { app: isolatedApp, auth: isolatedAuth, db: getFirestore(isolatedApp) };
}

export { auth, db, storage, googleProvider };
export default app;
